/*
 * @Author: liangtengfeng liangtengfeng@meizu.com
 * @Date: 2023-03-16 15:05:17
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-03-28 19:49:23
 * @FilePath: /flyme-10/src/assets/vue/directives/ia.js
 * @Description: 动画指令
 */

import { IntersectionInspect } from '@/assets/vue/lib/intersection-inspect'

const intersectionInspect = new IntersectionInspect()

const intersectionAnimation = {
  observe(el, elConfig) {
    let scrollY = 0
    if (elConfig) {
      intersectionInspect.observe(el, function (item) {
        const goUp = window.scrollY <= scrollY
        scrollY = window.scrollY
        if (!item.isIntersecting) {
          // 向上滚
          if (goUp) {
            elConfig.disAppear && elConfig.disAppear(item.target)
          }
          return
        }
        elConfig.appear && elConfig.appear(item.target)
      })
    }
  },
  unobserve(el) {
    intersectionInspect.unobserve(el)
  },
}

const anMap = new Map([
  [
    'fade',
    {
      appear: function (el) {
        el.style.transition =
          'transform 750ms cubic-bezier(0.24,0,0.12,1), opacity 383ms cubic-bezier(0.33,0,0.67,1)'
        el.style.transform = 'none'
        el.style.opacity = 1
      },
      disAppear: function (el) {
        el.style.transition = 'all 0s ease 0s'
        el.style.transform = 'translateY(84px)'
        el.style.opacity = 0
      },
    },
  ],
  [
    'lateral',
    {
      appear: function (el) {
        const children = Array.from(el.children)
        const length = children.length
        if (length) {
          Array.from(children).forEach((item) => {
            item.style.transition = 'transform 0.5s ease-in-out'
          })
          const isEven = length % 2 === 0
          const center = parseInt(length / 2)
          children.slice(0, center).map((item) => {
            item.style.transform = 'translateX(-120px)'
          })
          children.slice(isEven ? center : center + 1).map((item) => {
            item.style.transform = 'translateX(120px)'
          })
        }
        console.log('he', children, length)
      },
      disAppear: function (el) {
        const children = Array.from(el.children)
        const length = children.length
        if (length) {
          children.forEach((item) => {
            item.style.transition = 'all 0s ease 0s'
            item.style.transform = 'none'
          })
        }
      },
    },
  ],
])

export default {
  bind: function (el, config) {
    let options = config.value
    if (typeof options === 'string' && anMap.has(options)) {
      options = anMap.get(options)
    }
    options = options || anMap.get('fade')
    intersectionAnimation.observe(el, options)
  },
  unbind: function (el) {
    intersectionAnimation.unobserve(el)
  },
}
